import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { Card, Form, Alert } from 'react-bootstrap'
import { DocumentImage } from '../DocumentImage'
import StudentValidateButtons from '../StudentValidateButtons'
import AdminValidateButtons from '../AdminValidateButtons'
import { DocumentLabelStatus } from '../DocumentLabelStatus'
import { DocumentDate } from '../DocumentDate'
import NssInput from '../NssInput'
import NssInputAdmin from  '../NssInputAdmin'
import PendingButton from '../PendingButton'
import DocumentMessages from '../DocumentMessages'


 const Document = (props) => {
  const { auth, documento, nombre, slug, controlNumber, nss, equivalencia } = props
  const { user } = auth

  const nssRef = useRef()

  const [file, setFile] = useState({
    aceptado: null,
    observaciones: '',
    updated_at: '',
    pendiente: false,
    razon_pendiente: ''
  })

  useEffect( () => {
    setFile(documento)
  }, [])


  return (
  <Card>
    <DocumentImage src={documento !== undefined && documento.thumbnail} />
    <Card.Body>
      <Card.Title><strong>{nombre}</strong></Card.Title>
      <Card.Title>
        { 'inscrito' in user && <StudentValidateButtons file={file} setFile={setFile} slug={slug} nssRef={nssRef}/> }
        { user.role && <AdminValidateButtons file={file} setFile={setFile} slug={slug} controlNumber={controlNumber} nss={slug === 'registro-imss' && nss} /> }
        <DocumentLabelStatus file ={file} />
      </Card.Title>
      {
        slug === 'registro-imss' && 
        !user.role && 
          (
            <Form.Group>
              <NssInput nssRef={nssRef} />
              <Alert className="mt-1" variant="info">
                <strong>Favor de capturar su N&uacute;mero de Seguro Social</strong> antes de subir el documento. En caso de no coincidir su documentaci&oacute;n ser&aacute; <strong>rechazada</strong>. Para tramitar tu registro ante el IMMS, da clic <a href="http://imss.gob.mx/faq/seguro-estudiantes" target="_blank"><b>aquí</b></a> y sube el registro en este apartado.
              </Alert>
            </Form.Group>
          ) 
      }
      { /** input fiel for admin user */
        user.role && slug === 'registro-imss' && documento &&<NssInputAdmin />
      }
      {
        !user.role && <DocumentMessages slug={slug} equivalencia={equivalencia} />
      }
      <PendingButton numeroControl={controlNumber} slug={slug} documento={file} setFile={setFile} />
    </Card.Body>
    <Card.Footer>
      <DocumentDate date={ documento !== undefined && documento.updated_at}/>
    </Card.Footer>
  </Card>
  )
}
// href="http://ith.mx/documentos/ITH-AC-PO-001-02%20SOLICITUD%20DE%20INSCRIPCION.pdf
const mapStateToProps = state => ({
  auth : state.auth
})

export default connect(mapStateToProps, null)(Document)
